import { render } from "./TermsOfService.vue?vue&type=template&id=495625ca"
const script = {}

import "./TermsOfService.vue?vue&type=style&index=0&id=495625ca&lang=css"

import exportComponent from "../../../../../../../../../Users/kmg/Documents/VS Code/Classwork/poker-session-tracker-vue3/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__